import i18n from '@/utils/i18n';
import moment from 'moment-timezone';

const MS_PER_MINUTE = 60 * 1000;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;
const MS_PER_WEEK = 7 * MS_PER_DAY;

export const formatLastRun = (
  lastCompletedAt: string | null,
): string | null => {
  if (!lastCompletedAt) {
    return null;
  }
  const completedAt = moment(lastCompletedAt);
  if (!completedAt.isValid()) {
    return null;
  }

  const elapsedMs = Math.max(0, moment().diff(completedAt));

  if (elapsedMs < MS_PER_HOUR) {
    return i18n.t('pricing.agent.last_run_minutes', {
      minutes: Math.max(1, Math.floor(elapsedMs / MS_PER_MINUTE)),
    });
  }
  if (elapsedMs < MS_PER_DAY) {
    return i18n.t('pricing.agent.last_run_hours', {
      hours: Math.floor(elapsedMs / MS_PER_HOUR),
    });
  }
  if (elapsedMs < MS_PER_WEEK) {
    return i18n.t('pricing.agent.last_run_days', {
      days: Math.floor(elapsedMs / MS_PER_DAY),
    });
  }
  return i18n.t('pricing.agent.last_run_weeks', {
    weeks: Math.floor(elapsedMs / MS_PER_WEEK),
  });
};
